export default __webpack_public_path__ + "static/cropcovers-35fdd366cb6c2ee81ee6f23a7ce50a1a.jpg";